import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  state('enter', style({ opacity: 1 })),
  state('exit', style({ opacity: 0 })),
  state('void', style({ opacity: 0 })),
  transition('* <=> *', animate('400ms ease')),
]);

export const scaleInOut = trigger('scaleInOut', [
  state('enter', style({ transform: 'scale(1)' })),
  state('exit', style({ transform: 'scale(0)' })),
  state('void', style({ transform: 'scale(0)' })),
  transition('* <=> *', animate('200ms ease')),
]);

export const mouseDown = trigger('mouseDown', [
  state('true', style({ transform: 'scale(0.92)' })),
  state('false', style({ transform: 'scale(1)' })),
  state('void', style({ transform: 'scale(1)' })),
  transition('* <=> *', animate('100ms ease')),
]);
